import { clsx } from 'clsx'

import { Image } from '@tribeplatform/gql-client/types'
import { Image as ImageComponent } from '@tribeplatform/react-components/common/components'
import { useAuthToken } from '@tribeplatform/react-sdk/hooks'
import { useColorSchemeContext } from '@tribeplatform/react-ui-kit/ThemeProvider'

import { getAssetPath } from '../../configs/static.js'

export const SquareLogo = ({
  image: imageProp,
  size = 'sm',
}: {
  image?: Image
  size?: 'xs' | 'sm'
}) => {
  const { data: authToken } = useAuthToken()
  const { networkPublicInfo } = authToken || {}
  const { colorSchemeMode } = useColorSchemeContext()

  const { images } = networkPublicInfo || {}
  const fallbackLogo = images?.lightMobileLogo ?? networkPublicInfo.favicon

  const lightImage =
    imageProp ?? ((images?.lightMobileLogo ?? fallbackLogo) as Image)
  const darkImage =
    imageProp ?? ((images?.darkMobileLogo ?? fallbackLogo) as Image)

  const image = colorSchemeMode === 'dark' ? darkImage : lightImage

  const imageUrl = image?.urls?.small ?? image?.url

  let height
  let width
  let sizeClsx

  switch (size) {
    case 'xs':
      height = 24
      width = 24
      sizeClsx = 'h-6 w-6'
      break
    default:
    case 'sm':
      height = 32
      width = 32
      sizeClsx = 'h-8 w-8'
      break
  }

  if (!imageUrl) {
    return (
      <ImageComponent
        className={clsx(
          'inline-block object-contain square-logo-image rounded-base',
          sizeClsx,
        )}
        height={height}
        width={width}
        src={getAssetPath('images/default-icon.svg')}
        alt={networkPublicInfo.name}
      />
    )
  }

  if (colorSchemeMode === null) {
    // on SSR we don't have access to the colorSchemeMode, that's why we need to render both logos and let browser decide which one to show
    return (
      <>
        <ImageComponent
          className={clsx(
            'inline-block dark:hidden object-contain square-logo-image',
            sizeClsx,
          )}
          src={imageUrl}
          alt={networkPublicInfo.name}
        />
        <ImageComponent
          className={clsx(
            'hidden dark:inline-block object-contain square-logo-image',
            sizeClsx,
          )}
          src={imageUrl}
          alt={networkPublicInfo.name}
        />
      </>
    )
  }

  return (
    <ImageComponent
      className={clsx(
        'inline-block object-contain square-logo-image',
        sizeClsx,
      )}
      height={height}
      width={width}
      src={imageUrl}
      alt={networkPublicInfo.name}
    />
  )
}
